import * as React from "react";

export class StaticProgressbar extends React.Component<{}, {}> {

    render() {
        return (
            <div className="rj-pulse-bet__track">
                <div className="rj-pulse-bet__track-wrap rj-pulse-bet__track-wrap--static">
                    <div className="rj-pulse-bet__track-bg rj-pulse-bet__track-bg--static"></div>
                    <div className="rj-pulse-bet__track-point rj-pulse-bet__track-point--static">0</div>
                </div>
            </div>
        )
    }
}